import React from "react";
import { Tag, Typography } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";
import type { TFunction } from "i18next";

import type { Connection } from "@/providers/smarta-documents/documents-api-client";
import { Label, Tbody, Td, Tr, Value } from "../../components/styles";
import { DISPLAY_DATE_TIME_FORMAT } from "@/v1/constants";
import { AccountingSystem } from "./AccountingSystem";

const getTexts = (t: TFunction) => ({
  labels: {
    createdAt: t("connectionTable.labels.createdAt"),
    lastSyncedAt: t("connectionTable.labels.lastSyncedAt"),
    historicalStartDate: t("connectionTable.labels.historicalStartDate"),
    archived: t("connectionTable.labels.archived"),
    active: t("connectionTable.labels.active"),
    pending: t("connectionTable.labels.pending"),
    errored: t("connectionTable.labels.errored"),
  },
});

type Props = {
  data: Connection;
  customerId: string;
};

export const ConnectionTable: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation("Documents");
  const texts = getTexts(t);
  const {
    targetSystem,
    historicalStartDate,
    createdAt,
    lastSyncedAt,
    archivedAt,
    state,
  } = data;

  return (
    <Tbody>
      <Tr isHeaderRow hasBorder>
        <Td>
          <AccountingSystem targetSystem={targetSystem} />
        </Td>
        <Td />
        <Td>
          <Label>{texts.labels.createdAt}</Label>
          <Value>{moment(createdAt).format(DISPLAY_DATE_TIME_FORMAT)}</Value>
        </Td>
        <Td>
          <Label>{texts.labels.lastSyncedAt}</Label>
          <Value>{moment(lastSyncedAt).format(DISPLAY_DATE_TIME_FORMAT)}</Value>
        </Td>
        <Td>
          <Label>{texts.labels.historicalStartDate}</Label>
          <Value>
            {moment(historicalStartDate).format(DISPLAY_DATE_TIME_FORMAT)}
          </Value>
        </Td>
        <Td className="text-right">
          {archivedAt ? (
            <Tag>
              <Typography.Text type="secondary">
                {texts.labels.archived}
              </Typography.Text>
            </Tag>
          ) : state === "pending" ? (
            <Tag color="processing">{texts.labels.pending}</Tag>
          ) : state === "errored" ? (
            <Tag color="error">{texts.labels.errored}</Tag>
          ) : (
            <Tag color="success">{texts.labels.active}</Tag>
          )}
        </Td>
      </Tr>
    </Tbody>
  );
};
